// extracted by mini-css-extract-plugin
export default {"inputContainer":"Inputs_inputContainer__TvqrD","inputLabel":"Inputs_inputLabel__Ufq+O"};